var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuideCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 766,
    viewBox: "0 0 284 766",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.383301 383.001C0.383301 181.615 125.265 16.4935 284 0.812012V222.223C223.135 236.628 177.123 303.134 177.123 383.001C177.123 462.868 223.135 529.374 284 543.779V765.19C125.265 749.509 0.383301 584.387 0.383301 383.001Z",
    fill: "url(#paint0_linear_306_778)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_778",
    x1: 508.076,
    y1: 59.9264,
    x2: 227.904,
    y2: 644.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00976084,
    stopColor: "#42D09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D09F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideCircle1);
export default __webpack_public_path__ + "static/media/Guide_Circle1.40171b2387c6cb467493f55d1bd3318a.svg";
export { ForwardRef as ReactComponent };